import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'פרסונה',
    description: 'סטודיו למשחק ותיאטרון לילדים ולנוער. חוגים לפי גיל, אימפרוביזציה, דמויות ובמה, והרשמה מהירה לשיעור ניסיון.',
    placeholder: 'הבמה מחכה לכם.',
    url: getOrigin()
}

export const NAV_LINKS = [
    { href: '#why', label: 'למה תיאטרון' },
    { href: '#classes', label: 'החוגים' },
    { href: '#how', label: 'שיעור ניסיון' },
    { href: '#faq', label: 'שאלות' }
]
